export const PlaceholderButton = () => {
  return (
    <div className={`cursor-pointer flex items-center justify-start h-8 p-2 relative text-black no-underline`}>
      <div className={`bg-gray rounded-lg h-4 overflow-hidden relative w-full`}>
        <span
          className={`absolute inset-0 animate-pulse bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200`}
          aria-hidden="true"
        />
      </div>
    </div>
  );
};
